<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 入账编號" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">入账</el-button> -->
					<el-tag class="ml-3" type="warning">總金額：{{total_list.money}}</el-tag>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="入账编號" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索入账编號"></el-input>
						</el-form-item>
						
					
						
						<el-form-item label="店铺" class="mb-0">
							<el-select  v-model="from.shop_id" size="small" filterable placeholder="請選擇" >
								<el-option label="全部" :value="-1"></el-option>
								<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="店長" class="mb-0">
							<el-select  v-model="from.sid" size="small" filterable placeholder="請選擇" >
								<el-option label="全部" :value="-1"></el-option>
								<el-option v-for="item in sad_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						
						
						
						
						
						<el-form-item label="产品" class="mb-0">
							<el-select  v-model="from.pid" size="small" filterable placeholder="請選擇" >
								<el-option label="全部" :value="-1"></el-option>
								<el-option v-for="item in product" :key="item.id" :label="item.name+'( '+item.number+' )'" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
					
						
						
					
						
					
				
						
				

					
						
					


						<el-form-item label="入账時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<!-- <el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column> -->
				<el-table-column fixed align="center" width="60" prop="id" label="ID">
				</el-table-column>
				
				<el-table-column type="expand" label="明细" width="50">
				  <template slot-scope="v">
						<el-table
						    :data="v.row.log"
						    border
							show-summary
						    style="width: 100%;">
							
							<el-table-column align="center" prop="name"  label="项目"></el-table-column>
							<el-table-column align="center" prop="other"  label="其中"></el-table-column>
							<el-table-column align="center" prop="info"  label="明细"></el-table-column>
							<el-table-column align="center" prop="num"  label="數量"></el-table-column>
							<el-table-column align="center" prop="price"  label="單价"></el-table-column>
							<el-table-column align="center" prop="total"  label="金額"></el-table-column>
						  </el-table>
				  </template>
				</el-table-column>
				
				
				
			
				
				
		
				
				<el-table-column width="210" align="center" prop="order_no" label="入账编號"></el-table-column>
				<el-table-column align="center" width="120"  prop="shop_name" label="所属店铺"></el-table-column>
				<el-table-column align="center" width="120"  prop="sad_name" label="入账店長"></el-table-column>
				
				<el-table-column align="center" prop="client_name"  label="客戶名稱"></el-table-column>
				<el-table-column align="center" prop="pro_name"  width="160"  label="产品"></el-table-column>
			
				
				
				
			
				
			
				<el-table-column align="center" prop="total" width="110" label="總金額"></el-table-column>
				<el-table-column align="center" prop="print_num"  label="打印次數"></el-table-column>
				
	
			
		
				<!-- 
				<el-table-column align="center" sortable="custom" prop="status"  label="狀態">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			 -->
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="入账時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="160" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">操作</el-button>
							
							<el-button @click="printData(scope.row)"   size="mini" plain type="warning"><i class="el-icon-printer"></i> 打印</el-button>

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'销售入账':'修改入账'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'60%'">
			<!-- 表單内容 -->
			<el-form :inline="true" :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'60px':'60px'" :label-position="layout.is_phone?'top':'left'">
				
				
				<el-form-item label="客戶名稱" prop="client_name" label-width="80px" class="mb-0">
					<el-input type="text" v-model="form.client_name" 
					placeholder="輸入客戶名稱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item  label="产品" prop="pid" label-width="60px" class="mb-0">
					<el-select  v-model="form.pid" size="small" filterable placeholder="請選擇" style="width: 85%;" >
						<el-option  label="无产品" :value="0">
						</el-option>
						<el-option v-for="item in product" :key="item.id" :label="item.name+'( '+item.number+' )'" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				

				<hr>
				
				
				<div style="height: 400px; overflow-y: auto;">
					<el-tag type="danger">行-1</el-tag>
					<br>
					
					
					<el-form-item label="项目" prop="class_id">
						<el-select @change="selClassify" v-model="form.cid_1" size="small" filterable placeholder="請選擇" style="width: 85%;" >
							<el-option v-for="item in c_list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="其中" prop="other">
						<el-input type="text" v-model="form.other_1" 
						placeholder="其中" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="明细" prop="info">
						<el-input type="text" v-model="form.info_1" 
						placeholder="明细(備註)" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="數量" prop="num">
						<el-input type="number" v-model="form.num_1"  @input="jisTotal"
						placeholder="數量" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="單价" prop="price">
						<el-input type="number" v-model="form.price_1"  @input="jisTotal"
						placeholder="單价" 
						clearable size="small" style="width: 85%;">
						<template slot="prepend">HK$</template>
						</el-input>
					</el-form-item>
					
					
					<el-form-item label="金額" prop="total">
						<span>HK$ {{form.total_1}}</span>
					</el-form-item>
					
					
					<hr>
					
					<el-tag type="danger">行-2</el-tag>
					<br>
					<el-form-item label="项目" prop="class_id">
						<el-select @change="selClassify" v-model="form.cid_2" size="small" filterable placeholder="請選擇" style="width: 85%;" >
							<el-option v-for="item in c_list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="其中" prop="other">
						<el-input type="text" v-model="form.other_2" 
						placeholder="其中" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="明细" prop="info">
						<el-input type="text" v-model="form.info_2" 
						placeholder="明细(備註)" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="數量" prop="num">
						<el-input type="number" v-model="form.num_2"  @input="jisTotal"
						placeholder="數量" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="單价" prop="price">
						<el-input type="number" v-model="form.price_2"  @input="jisTotal"
						placeholder="單价" 
						clearable size="small" style="width: 85%;">
						<template slot="prepend">HK$</template>
						</el-input>
					</el-form-item>
					
					
					<el-form-item label="金額" prop="total">
						<span>HK$ {{form.total_2}}</span>
					</el-form-item>
					
					
					<hr>
					
					<el-tag type="danger">行-3</el-tag>
					<br>
					
					<el-form-item label="项目" prop="class_id">
						<el-select @change="selClassify" v-model="form.cid_3" size="small" filterable placeholder="請選擇" style="width: 85%;" >
							<el-option v-for="item in c_list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="其中" prop="other">
						<el-input type="text" v-model="form.other_3" 
						placeholder="其中" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="明细" prop="info">
						<el-input type="text" v-model="form.info_3" 
						placeholder="明细(備註)" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="數量" prop="num">
						<el-input type="number" v-model="form.num_3"  @input="jisTotal"
						placeholder="數量" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="單价" prop="price">
						<el-input type="number" v-model="form.price_3"  @input="jisTotal"
						placeholder="單价" 
						clearable size="small" style="width: 85%;">
						<template slot="prepend">HK$</template>
						</el-input>
					</el-form-item>
					
					
					<el-form-item label="金額" prop="total">
						<span>HK$ {{form.total_3}}</span>
					</el-form-item>
					
					
					
					<hr>
					
					<el-tag type="danger">行-4</el-tag>
					<br>
					
					<el-form-item label="项目" prop="class_id">
						<el-select @change="selClassify" v-model="form.cid_4" size="small" filterable placeholder="請選擇" style="width: 85%;" >
							<el-option v-for="item in c_list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="其中" prop="other">
						<el-input type="text" v-model="form.other_4" 
						placeholder="其中" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="明细" prop="info">
						<el-input type="text" v-model="form.info_4" 
						placeholder="明细(備註)" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="數量" prop="num">
						<el-input type="number" v-model="form.num_4"  @input="jisTotal"
						placeholder="數量" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="單价" prop="price">
						<el-input type="number" v-model="form.price_4"  @input="jisTotal"
						placeholder="單价" 
						clearable size="small" style="width: 85%;">
						<template slot="prepend">HK$</template>
						</el-input>
					</el-form-item>
					
					
					<el-form-item label="金額" prop="total">
						<span>HK$ {{form.total_4}}</span>
					</el-form-item>
					
					
					
					<hr>
					
					<el-tag type="danger">行-5</el-tag>
					<br>
					
					<el-form-item label="项目" prop="class_id">
						<el-select @change="selClassify" v-model="form.cid_5" size="small" filterable placeholder="請選擇" style="width: 85%;" >
							<el-option v-for="item in c_list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="其中" prop="other">
						<el-input type="text" v-model="form.other_5" 
						placeholder="其中" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="明细" prop="info">
						<el-input type="text" v-model="form.info_5" 
						placeholder="明细(備註)" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					
					<el-form-item label="數量" prop="num">
						<el-input type="number" v-model="form.num_5"  @input="jisTotal"
						placeholder="數量" 
						clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item label="單价" prop="price">
						<el-input type="number" v-model="form.price_5"  @input="jisTotal"
						placeholder="單价" 
						clearable size="small" style="width: 85%;">
						<template slot="prepend">HK$</template>
						</el-input>
					</el-form-item>
					
					
					<el-form-item label="金額" prop="total">
						<span>HK$ {{form.total}}</span>
					</el-form-item>
								
					
					
					
						
					<hr>
				</div>
				
				
			
				<p style="text-align: right;" class="mb-0">
					合計：<el-tag class="ml-3 mr-3" type="success">HK$ {{form.total}}</el-tag>
				</p>

				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		
		
		
		<el-dialog :close-on-click-modal="false"  title="打印票据" :visible.sync="printModel" 
		top="5vh" :width="layout.is_phone?'90%':'60%'">
			<!-- 表單内容 -->
			<el-form :rules="rules_print" ref="formEdit2" :model="print_sub" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				<div style="width: 100%;overflow-x: auto;">
					<div style="width: 822px;" class="mb-3">
						<div class="text-center mb-1" style="font-size: 20px;">{{print_sub.shop_name}}</div>
						<div class="text-center mb-1" style="font-size: 17px;">{{print_sub.name_en}}</div>
						<div class="text-center mb-1" style="font-size: 17px;">{{print_sub.local}}</div>
						<div class="text-center mb-1" style="font-size: 20px;">发 INVOICE 票</div>
						
						<div class="print_fj" >
							<div>客戶：{{print_sub.client_name}}</div>
							<div class="print_fj" style="width: 430px;">
								<div>发票编號：{{print_sub.order_no}}</div>
								<div>开票日期：{{print_sub.date}}</div>
							</div>
						</div>
						<table class="print_table">
							<tr>
								<th>项目</th>
								<th>其中</th>
								<th>明细</th>
								<th>數量</th>
								<th>單价</th>
								<th>金額</th>
							</tr>
							<tr v-for="item in print_sub.log" :key="item.id">
								<td>{{item.name}}</td>
								<td>{{item.other}}</td>
								<td>{{item.info}}</td>
								<td>{{item.num}}</td>
								<td>{{item.price}}</td>
								<td>{{item.total}}</td>
							</tr>
						</table>
						<div class="print_fj">
							<div>
								操作员：{{print_sub.name}}
							</div>
							
							<div class="print_fj" style="width: 200px;">
								<div>合計</div>
								<div>{{print_sub.total}}</div>
							</div>
						</div>
					</div>
				</div>
				
				
				
				<el-form-item  label="打印机" prop="print_id"  class="mb-0">
					<el-select  v-model="print_sub.print_id" size="small" filterable placeholder="請選擇" style="width: 85%;" >
						<el-option  label="請選擇打印机" disabled :value="0">
						</el-option>
						<el-option v-for="item in print_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
	
				
				
				
			
		
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="printModel = false">取 消</el-button>
				<el-button :disabled="printload" type="primary" @click="submitPrint">確 定</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules_print: {
				
					print_id: [{
							required: true,
							message: "請選擇打印机",
							trigger: 'blur',
						},
					],
				
				},
				rules: {
				
					client_name: [{
							required: true,
							message: "請輸入客戶名稱",
							trigger: 'blur',
						},
					],

				},
				createModel: false,
				printModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					shop_id:-1,
					sid:-1,
					parent_type:-1,
					class_id:-1,
					pid:-1,
					info:'',
					time: [],
				},
				model_title: 'Pay',
				auth_val: 'Pay',
				preUrl: "user/payList", //列表地址
				addUrl: "user/addPay", //添加/修改地址
				editStatusUrl: "user/editStatusPay", //修改狀態地址
				tableData: [],
				print_sub:{
					id:0,
					print_id:'',
				},
				form: {
					id: 0,
					pid:'',
					client_name:'',
					
					cid_1:'',
					other_1:'',
					info_1:'',
					num_1:'',
					price_1:'',
					total_1:0,
					
					cid_2:'',
					other_2:'',
					info_2:'',
					num_2:'',
					price_2:'',
					total_2:0,
					
					cid_3:'',
					other_3:'',
					info_3:'',
					num_3:'',
					price_3:'',
					total_3:0,
					
					cid_4:'',
					other_4:'',
					info_4:'',
					num_4:'',
					price_4:'',
					total_4:0,
					
					cid_5:'',
					other_5:'',
					info_5:'',
					num_5:'',
					price_5:'',
					total_5:0,
					
					total:0
					
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				
				c_list:[],
				product:[],
				shop_list:[],
				sad_list:[],
				print_list:[],
				printload:false
				
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('payClass');
		},
		methods: {
			jisTotal(){
				if(this.form.num_1 && this.form.price_1){
					this.form.total_1 = this.form.num_1 * this.form.price_1
				}
				if(this.form.num_2 && this.form.price_2){
					this.form.total_2 = this.form.num_2 * this.form.price_2
				}
				if(this.form.num_3 && this.form.price_3){
					this.form.total_3 = this.form.num_3 * this.form.price_3
				}
				if(this.form.num_4 && this.form.price_4){
					this.form.total_4 = this.form.num_4 * this.form.price_4
				}
				if(this.form.num_5 && this.form.price_5){
					this.form.total_5 = this.form.num_5 * this.form.price_5
				}
				
				this.form.total = this.form.total_1 + this.form.total_2 + this.form.total_3 + this.form.total_4 + this.form.total_5
			},
			selClassify(e){
				let item = this.c_list.find(v=>v.id==e)
				this.form.is_product = item.is_product
			},
			selPt(e){
				if(e==1){
					this.c_list = this.paylist
				}else{
					this.c_list = this.guanlist
				}
				this.form.class_id = ''
				this.form.is_product = 0
			},
			commonList(type){
					this.axios.post('/admin/user/commonList',
						{type:type}
					, {
						token: true,
					}).then(res => {
						let all = res.data
						
						let list = all.data.list
						this.c_list = list.all
						this.product = list.pro
						this.shop_list = list.shop
						this.sad_list = list.sad
						this.print_list = list.print
						
					}).catch(err => {
						// 失敗
						
					})
				
			},
			
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				this.$refs.formEdit.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
			
			//提交
			submitPrint() {
				this.$refs.formEdit2.validate(res => {
					if (res) {
						this.submitPrintApi()
						// 關閉模态框
					}
				})
			},
			submitPrintApi(){
				this.printload = true
				this.axios.post('/admin/user/openPrint',
					this.print_sub
				, {
					token: true,
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.$message({
							message: all.msg,
							type: 'success'
						});
						
						
						this.printModel = false
						this.getList()
					}
					this.printload = false
				}).catch(err => {
					// 失敗
					this.printModel = false
					this.printload = false
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			  
			printData(e){
				
				let log = [];
				let log_len = e.log.length
				console.log(log_len)
				for(let i = 0;i<10;i++){
					let j = i/2
					let is_have =false
					if(Number.isInteger(j)){
						let jj = j+1;
						if(jj<=log_len){
							is_have = true
						}
					}
					let arr = {}
					if(is_have){
						arr = {
							name:e.log[j].name,
							other:e.log[j].other,
							info:e.log[j].info,
							num:e.log[j].num,
							price:e.log[j].price,
							total:e.log[j].total,
						}
					}else{
						arr = {name:'',other:'',info:'',num:'',price:'',total:''}
					}
					log.push(arr)
				}
				
				this.print_sub = {
					id:e.id,
					order_no:e.order_no,
					client_name:e.client_name,
					log:log,
					shop_name:e.shop_name,
					name_en:e.name_en,
					local:e.local,
					date:e.date,
					total:e.total,
					name:e.sad_name,
					print_id:''
				}
				
				this.printModel = true
			},
			

			// 打开模态框
			openModel(e, type) {
				
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						pid: e.pid,
						client_name:e.client_name,
						
						cid_1:e.cid_1,
						other_1:e.other_1,
						info_1:e.info_1,
						num_1:e.num_1,
						price_1:e.price_1,
						total_1:e.total_1,
						
						cid_2:e.cid_2,
						other_2:e.other_2,
						info_2:e.info_2,
						num_2:e.num_2,
						price_2:e.price_2,
						total_2:e.total_2,
						
						
						cid_3:e.cid_3,
						other_3:e.other_3,
						info_3:e.info_3,
						num_3:e.num_3,
						price_3:e.price_3,
						total_3:e.total_3,
						
						cid_4:e.cid_4,
						other_4:e.other_4,
						info_4:e.info_4,
						num_4:e.num_4,
						price_4:e.price_4,
						total_4:e.total_4,
						
						cid_5:e.cid_5,
						other_5:e.other_5,
						info_5:e.info_5,
						num_5:e.num_5,
						price_5:e.price_5,
						total_5:e.total_5,
						
						
						total:e.total,
					}
					this.editIndex = e.id
					
					
				}else{
					this.form = {
						id: 0,
						pid:'',
						client_name:'',
						
						cid_1:'',
						other_1:'',
						info_1:'',
						num_1:'',
						price_1:'',
						total_1:0,
						
						cid_2:'',
						other_2:'',
						info_2:'',
						num_2:'',
						price_2:'',
						total_2:0,
						
						cid_3:'',
						other_3:'',
						info_3:'',
						num_3:'',
						price_3:'',
						total_3:0,
						
						cid_4:'',
						other_4:'',
						info_4:'',
						num_4:'',
						price_4:'',
						total_4:0,
						
						cid_5:'',
						other_5:'',
						info_5:'',
						num_5:'',
						price_5:'',
						total_5:0,
						
						total:0
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					shop_id:-1,
					sid:-1,
					parent_type:-1,
					class_id:-1,
					pid:-1,
					info:'',
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
	.print_fj{
		display: flex;
		justify-content: space-between;
	}
	.print_table{
		width: 100%;
		margin: 10px 0;
	}
	.print_table td,.print_table th{
		font-weight: normal;
		border:1px solid #ccc;
		text-align: center;
		line-height: 25px;
		height: 25px;
		font-size: 13px;
	}
</style>
